(() => {
  const imageSelector = '[data-heirvale-card-image]';
  const dotSelector = '[data-heirvale-card-dot]';
  let gesture = null;
  let touchGesture = null;
  let suppressed = null;

  function showImage(gallery, index) {
    const images = [...gallery.querySelectorAll(imageSelector)];
    const dots = [...gallery.querySelectorAll(dotSelector)];
    if (!images.length || index < 0 || index >= images.length) return;

    images.forEach((image, position) => {
      const active = position === index;
      image.classList.toggle('is-active', active);
      if (active) image.removeAttribute('aria-hidden');
      else image.setAttribute('aria-hidden', 'true');
    });
    dots.forEach((dot, position) => {
      const active = position === index;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-pressed', String(active));
    });
  }

  function currentIndex(gallery) {
    return [...gallery.querySelectorAll(imageSelector)].findIndex(image => image.classList.contains('is-active'));
  }

  function swipeImage(card, gallery, dx, dy) {
    if (Math.abs(dx) < 28 || Math.abs(dx) < Math.abs(dy) * 1.25) return false;
    const count = gallery.querySelectorAll(imageSelector).length;
    if (count < 2) return false;
    const next = (currentIndex(gallery) + (dx < 0 ? 1 : -1) + count) % count;
    showImage(gallery, next);
    suppressed = { card, until: Date.now() + 500 };
    return true;
  }

  function galleryAtPoint(target, x, y) {
    if (target.closest('.quick-add') || target.closest(dotSelector)) return null;
    const card = target.closest('.heirvale-listing-card');
    const gallery = card?.querySelector('[data-heirvale-card-gallery]');
    if (!gallery) return null;
    const rect = gallery.getBoundingClientRect();
    if (x < rect.left || x > rect.right || y < rect.top || y > rect.bottom) return null;
    return { card, gallery, x, y };
  }

  document.addEventListener('click', event => {
    const dot = event.target.closest(dotSelector);
    if (dot) {
      const gallery = dot.closest('[data-heirvale-card-gallery]');
      if (!gallery) return;
      event.preventDefault();
      event.stopPropagation();
      showImage(gallery, Number(dot.dataset.heirvaleCardDot));
      return;
    }
    if (suppressed && Date.now() < suppressed.until && event.target.closest('.heirvale-listing-card') === suppressed.card) {
      event.preventDefault();
      event.stopPropagation();
      suppressed = null;
    }
  }, true);

  document.addEventListener('keydown', event => {
    const dot = event.target.closest(dotSelector);
    if (!dot || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    const gallery = dot.closest('[data-heirvale-card-gallery]');
    if (!gallery) return;
    const dots = [...gallery.querySelectorAll(dotSelector)];
    const current = dots.indexOf(dot);
    let next = current;
    if (event.key === 'ArrowLeft') next = (current - 1 + dots.length) % dots.length;
    if (event.key === 'ArrowRight') next = (current + 1) % dots.length;
    if (event.key === 'Home') next = 0;
    if (event.key === 'End') next = dots.length - 1;
    event.preventDefault();
    showImage(gallery, next);
    dots[next].focus();
  });

  document.addEventListener('pointerdown', event => {
    if (event.pointerType === 'touch' || (event.pointerType === 'mouse' && event.button !== 0)) return;
    const start = galleryAtPoint(event.target, event.clientX, event.clientY);
    gesture = start ? { ...start, pointerId: event.pointerId } : null;
  }, true);

  document.addEventListener('pointerup', event => {
    if (!gesture || event.pointerId !== gesture.pointerId) return;
    const { card, gallery, x, y } = gesture;
    gesture = null;
    if (swipeImage(card, gallery, event.clientX - x, event.clientY - y)) event.preventDefault();
  }, true);

  document.addEventListener('pointercancel', () => { gesture = null; }, true);

  document.addEventListener('dragstart', event => {
    if (gesture && event.target.closest('.heirvale-listing-card') === gesture.card) event.preventDefault();
  }, true);

  document.addEventListener('touchstart', event => {
    touchGesture = null;
    if (event.touches.length !== 1) return;
    const touch = event.touches[0];
    const start = galleryAtPoint(event.target, touch.clientX, touch.clientY);
    if (start) touchGesture = { ...start, identifier: touch.identifier };
  }, { capture: true, passive: true });

  document.addEventListener('touchend', event => {
    if (!touchGesture) return;
    const touch = [...event.changedTouches].find(item => item.identifier === touchGesture.identifier);
    if (!touch) return;
    const { card, gallery, x, y } = touchGesture;
    touchGesture = null;
    swipeImage(card, gallery, touch.clientX - x, touch.clientY - y);
  }, { capture: true, passive: true });

  document.addEventListener('touchcancel', () => { touchGesture = null; }, true);
})();
